<template>
  <b-modal
      id="modal-info-produto-id-new"
      title="Informações do Produto"
      ref="refModalInfoProduto"
      size="xl"
      no-close-on-esc
      hide-header
      no-close-on-backdrop
  >
    <template #modal-footer>
      <div style="display: flex;gap: 10px">
        <div>
          <b-button
              variant="danger"
              @click="onCancelModal"
          >
            <feather-icon icon="XIcon" class="mr-50"/>
            Cancelar
          </b-button>
        </div>
        <div>
          <b-button
              variant="success"
              @click="adicionarCarrinho"
          >
            <feather-icon icon="ShoppingCartIcon" class="mr-50"/>
            Adicionar
          </b-button>
        </div>
      </div>
    </template>
    <e-commerce-product-details />
    <pic-oferta-inline v-if="$store.getters['preferencias/picAtivo'] === true" :item="item" :context="pedidoContext" @use-pic="usarPic" />
    <b-modal
        id="modal-gallery-imagens"
        hide-footer
        hide-header
        style="height: 500px; width: 100%;background: transparent; border: none; padding: 0; margin: 0;"
        body-bg-variant="transparent"
    >
      <swiper
          ref="refSwiperGallery"
          class="swiper-gallery gallery-top"
          :options="swiperOptions"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      >
        <swiper-slide
            v-for="(data,index) in (itemImagens || [])"
            :key="index"
        >
          <b-img
              :src="data.caminho"
              fluid
          />
        </swiper-slide>

        <div
            slot="button-next"
            class="swiper-button-next swiper-button-white"
        />
        <div
            slot="button-prev"
            class="swiper-button-prev swiper-button-white"
        />
      </swiper>
    </b-modal>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { formtPriceBr } from '@core/utils/filter';
import 'swiper/css/swiper.css';
import GradeItem from '@/components/catalogo-produtos/GradeItem.vue';
import ECommerceProductDetails from '@/views/app/CartECommerce/e-commerce-product-details/ECommerceProductDetails.vue';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';
import PicOfertaInline from '@/components/catalogo-produtos/PicOfertaInline.vue';

export default {
  name: 'ModalInfoProduto',
  components: {
    ECommerceProductDetails,
    GradeItem,
    Swiper,
    SwiperSlide,
    PicOfertaInline,
  },
  filters: {
    formtPriceBr,
  },
  data() {
    return {
      tabActive: 0,
      showModal: true,
      slide: 0,
      imagemPadrao: IMAGEM_PADRAO,
      mainImg: IMAGEM_PADRAO,
      swiperOptions: {
        loop: true,
        loopedSlides: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      itemsCarrinho: [],
      items: [{
        id: 1,
        selected: 'male',
        selected1: 'designer',
        prevHeight: 0,
      }],
    };
  },
  computed: {
    ...mapGetters('ItemStore', {
      item: 'GET_CURRENT_ITEM',
    }),
    ...mapGetters('slsEmbalagem', {
      currentEmbalagem: 'getCurrentEsEmbalag',
    }),
    pedidoContext() {
      return this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
    },
    itemImagens() {
      return Array.isArray(this.item?.imagens) ? this.item.imagens : [];
    },
  },
  methods: {
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    updatedGrade(value) {
      const currentItem = this.item || {};
      const embalagem = this.currentEmbalagem || {};
      const imagens = this.itemImagens;
      this.itemsCarrinho = value.map((item) => {
        // const imagem = this.item.imagens.find(img => img.cdnCor === item.cdn_cor)
        const imagemPrincipal = imagens.find((item) => item.imagemPrincipal === 1);
        const caminhoImagemPrincipal = imagemPrincipal ? imagemPrincipal.caminho : null;
        this.$store.commit('PedidosStore/ADD_OR_UPDATE_PRODUCT_ITEM_PEDIDO', {
          cod_marca: currentItem.cod_marca,
          familia_comercial_id: currentItem.familia_comercial_id ?? currentItem.referencia ?? null,
          cdn_cor: item.cdn_cor,
          cdn_tamanho: item.cdn_tamanho,
          des_tamanho: item.tamanho,
          des_cor: item.des_cor,
          item_id: currentItem.item_id || currentItem.itemId || currentItem.CodItem,
          item_descricao: currentItem.item_descricao || currentItem.itemDescricao
            || `${currentItem.item_id || currentItem.itemId || ''} - ${currentItem.item_name || ''}`.trim(),
          // item_imagem: imagem ? imagem.caminho : 'https://dkpsales-novo-hanes.s3.amazonaws.com/images/images/produto-sem-imagem.png',
          item_imagem: caminhoImagemPrincipal,
          pedido_item_seq: 0,
          pic_id: 0,
          marca: currentItem.item_marca,
          embalagem: embalagem.des_embalag || '',
          cdn_embalag: embalagem.cdn_embalag || embalagem.cdn_embalagem || '',
          pedido_item_preco_unitario: parseFloat(currentItem.item_price_exibicao ?? currentItem.item_price),
          pedido_item_preco_unitario_base: parseFloat(currentItem.item_price_base ?? currentItem.item_price),
          pedido_item_quantidade: parseInt(item.valor, 10),
          valor_total: +(parseFloat((currentItem.item_price_exibicao ?? currentItem.item_price)) * parseFloat(item.valor)),
        });
        return {
          cod_marca: currentItem.cod_marca,
          familia_comercial_id: currentItem.familia_comercial_id ?? currentItem.referencia ?? null,
          cdn_cor: item.cdn_cor,
          des_cor: item.des_cor,
          cdn_tamanho: item.cdn_tamanho,
          des_tamanho: item.tamanho,
          item_id: currentItem.item_id || currentItem.itemId || currentItem.CodItem,
          item_descricao: currentItem.item_descricao || currentItem.itemDescricao
            || `${currentItem.item_id || currentItem.itemId || ''} - ${currentItem.item_name || ''}`.trim(),
          item_imagem: caminhoImagemPrincipal || IMAGEM_PADRAO,
          pedido_item_seq: 0,
          pic_id: 0,
          marca: currentItem.item_marca,
          embalagem: embalagem.des_embalag || '',
          cdn_embalag: embalagem.cdn_embalag || embalagem.cdn_embalagem || '',
          pedido_item_preco_unitario: parseFloat(currentItem.item_price_exibicao ?? currentItem.item_price),
          pedido_item_preco_unitario_base: parseFloat(currentItem.item_price_base ?? currentItem.item_price),
          pedido_item_quantidade: parseInt(item.valor, 10),
          valor_total: +(parseFloat((currentItem.item_price_exibicao ?? currentItem.item_price)) * parseFloat(item.valor)),
        };
      });
    },
    onCancelModal() {
      this.mainImg = IMAGEM_PADRAO;
      this.$refs.refModalInfoProduto.hide();
    },
    adicionarCarrinho() {
      this.$store.commit('ECommercerStore/ADD_OR_UPDATE_PRODUCT_TO_CART', {
        ...this.item,
        item_price: parseFloat(this.item.item_price),
        quantidade: 1,
      });
      this.$refs.refModalInfoProduto.hide();
    },
    usarPic(offer) {
      this.$root.$emit('openModal:pic', {
        type: 'info-pedido',
        operacao: 'create',
        data: null,
        itemid: offer.itemid || this.item.item_id,
        picid: offer.picid,
      });
    },
    openModal(startIndex) {
      this.showModal = true;
      // this.$refs.refSwiperGallery.$forceUpdate()
      this.$bvModal.show('modal-gallery-imagens');
      // this.$nextTick(() => {
      //   this.$refs.swiperTop.$swiper.slideTo(startIndex);
      // });
    },
  },

  mounted() {
    this.mainImg = this.itemImagens[0]?.caminho ?? IMAGEM_PADRAO;
  },
};
</script>

<style scoped>
.destaque {
  border: 1px solid red;
}

/* .imagens-container reservado */

.imagens-item-img {
  border: 1px solid var(--primary);
  width: 50px;
  height: 50px;
}

.imagens-item-img img {
  height: 50px;
}

.imagens-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .imagens-container {
    width: 100%;
    padding-bottom: 10px;
  }

  .imagens-item {
    flex-direction: row;
  }

  /* tamanhos de imagem controlados externamente */
}

/* Estilize a modal e o swiper conforme necessário */
.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide img {
  width: 100%;
  height: 100%;
}
</style>
